module.exports = __webpack_public_path__ + "static/crystal-heart-e133c2f42b141672fb2ef6ada769781b.png";